import React, {useCallback, useState} from 'react';
import PropTypes from "prop-types";
import JsonScreen from "../../../Components/JsonScreen";
import {Popper} from "@material-ui/core";
import JsonScreenHoc from "../../../HocHelpers/JsonScreenHoc";

// import JsonScreenFC from "../../../Components/JsonScreen/JsonScreenFC";

function getPopperWidth(columns = []) {
    if (!columns.length) return null;
    return columns.reduce((acc, curr) => {
        return acc + (curr.hidden ? 0 : curr.width ? parseInt(curr.width) : 150);
    }, 0);
}

function getTextWidth(text, font) {
    // re-use canvas object for better performance
    const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
    const context = canvas.getContext("2d");
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width;
}

const DropDown = (props) => {
    const {
        anchorEl,
        dropdownName,
        inputValue,
        searchUpdate,
        searchUpdateFalse,
        setFieldValue,
        fieldValue,
        open,
        history,
        doActions,
        dropdownProps: {restrictCreate, openCreate, dropdownContext, path, fieldValue: currentFieldValue}
    } = props;
    let [cols, setCols] = useState([]);
    let [height, setHeight] = useState(0);

    let minWidth = anchorEl ? anchorEl.clientWidth : null;
    const width = getPopperWidth(cols)
    const [maxDropdownWidth, setMaxDropdownWidth] = useState(width)
    let currentWidth = width > minWidth ? width : minWidth;
    const setColsMaxWidth = useCallback((cols = [], data = []) => {
        const colLengths = cols.map(col => {
            if (col.hidden) return 0
            if (col.width) return parseInt(col.width)
            const dataByColumn = data.map(v => {
                return getTextWidth(v[col.name], 'normal 12pt Rubik')
            });
            return dataByColumn.reduce((a, b) => (a || 0) >= (b || 0) ? a : b, 0)
        })
        setMaxDropdownWidth(colLengths.reduce((a, b) => a + b, 0))

    }, [])

    return (
        <Popper
            open={open}
            placement={"bottom-start"}
            disablePortal={false}

            anchorEl={anchorEl}
            style={{
                width: maxDropdownWidth < currentWidth ? currentWidth : maxDropdownWidth,
                height,
                zIndex: 9999
            }}
            role="presentation"
            modifiers={[
                {
                    name: 'flip',
                    enabled: true,
                    options: {
                        altBoundary: true,
                        rootBoundary: 'document',
                        padding: 8,
                    },
                },
            ]}
        >
            <div onMouseDown={(event => event.preventDefault())}>
                <JsonScreen
                    match={{params: {name: dropdownName}}}
                    customScreen={dropdownName}
                    doActions={doActions}
                    countColumns={setCols}
                    dropdownMode={true}
                    dropdownProps={{
                        openCreate,
                        restrictCreate,
                        dropdownContext,
                        path,
                        fieldValue: currentFieldValue,
                        _setHeight: setHeight,
                        setColsMaxWidth
                    }}
                    history={history}
                    keyPressed={props.keyPressed}
                    direction={props.direction}
                    location={{state: {}}}
                    currentFieldValue={inputValue}
                    setFreeSolo={props.setFreeSolo}
                    searchFieldUpdate={searchUpdate}
                    setFieldUpdateFalse={searchUpdateFalse}
                    setFieldValue={setFieldValue}
                    valuesDropdown={fieldValue}
                    onChangeFields={props.setValue}
                    // pathToField={path}
                    // record={record}
                    // currentOuterEntity={'entity'}
                />
            </div>
        </Popper>
    );
};

DropDown.propTypes = {
    anchorEl: PropTypes.any,
    onClose: PropTypes.func.isRequired,
    path: PropTypes.string.isRequired,
    dropdownName: PropTypes.string,
    inputValue: PropTypes.string,
    setFieldValue: PropTypes.func.isRequired,
    record: PropTypes.any.isRequired,
    fieldValue: PropTypes.any.isRequired,
    dropdownProps: PropTypes.object
};
DropDown.defaultProps = {
    dropdownProps: {}
};
export default JsonScreenHoc(DropDown);
